import Cookies from "js-cookie";

export const setToken = (token: string) => {
  Cookies.set("auth_token", token, { expires: 1 });
};

export const getToken = () => {
  return Cookies.get("auth_token");
};

export const removeToken = () => {
  Cookies.remove("auth_token");
};
